<div class="container">
    <form [formGroup]="loginForm" class="loginFormClass" autocomplete="off">
    <div class="lgFrmCard">
        <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <div class="input-field">
                <input formControlName="email" id="email" name="email" class="form-control" type="text"
                    placeholder="User@example.com" autocomplete="off">
            </div>
            <span class="text-danger"
                *ngIf="loginSubmitted() && loginForm.controls['email'].invalid && loginForm.controls['email'].dirty && loginForm.hasError('required','email')">
                Email is required.
            </span>
            <span class="text-danger"
                *ngIf="loginSubmitted()  && loginForm.controls['email'].value!='' && loginForm.controls['email'].hasError('pattern')">
                Please enter valid email.
            </span>
        </div> 
    @if(showBtn()){
        <div class="form-group">
            <label class="from-label" for="pwd">Password</label>
            <div class="input-field">
                <input formControlName="pwd" id="pwd" name="pwd" class="form-control" autocomplete="off"
                    [type]="type" placeholder="Password">
                    <span style="position: relative;">
                     <span class="fa {{eyeIcon}} passwordEye" (click)="hideShowPassword()"></span>
                   </span>
            </div>
            <span class="text-danger"
            *ngIf="loginSubmitted()  && loginForm.hasError('required','pwd')">
            Please enter password.
           </span>
            <span class="text-danger"
                *ngIf="loginSubmitted() && loginForm.controls['pwd'].invalid && loginForm.controls['pwd'].dirty && loginForm.hasError('pattern','pwd')">
                Enter valid password.
            </span>
        </div>
    }

    <!-- <button class="btn btn-primary signInBtn" type="submit" (click)="validateUserEmail()" *ngIf="!showBtn()">
        @if(spinner()){
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login">
                <span class="sr-only">Loading...</span>
            </i>
          } Continue
    </button> -->
<!-- CAPTCHA — shown after email verified, guards both OTP and password flows -->
@if(captchaReady()) {
  <div class="form-group captcha-group">
    <label class="form-label">Verify you are human</label>

    <div class="captcha-row">
      <div class="captcha-canvas-wrap">
        <canvas id="captchaCanvas" width="180" height="44"></canvas>
      </div>
      <button type="button" class="captcha-refresh-btn"
              (click)="generateCaptcha()"
              title="Refresh" aria-label="Refresh CAPTCHA">
        <i class="fa fa-refresh"></i>
      </button>
    </div>

    <div class="input-field">
      <input
        class="form-control"
        type="text"
        maxlength="6"
        placeholder="Case-sensitive, enter exactly as shown"
        [(ngModel)]="captchaInput"
        [ngModelOptions]="{standalone: true}"
        (input)="verifyCaptcha()"
        autocomplete="off"
      />
    </div>

    <span class="text-danger" *ngIf="captchaSubmitted && !captchaVerified">
      Incorrect characters. Please try again.
    </span>
  </div>
}


<!-- Continue button — before email verified -->
<button class="btn btn-primary signInBtn" type="submit"
        (click)="validateUserEmail()" *ngIf="!showBtn()">
  @if(spinner()) {
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login">
      <span class="sr-only">Loading...</span>
    </i>
  } Continue
</button>

<!-- Sign In button — after email verified -->
<button class="btn btn-primary signInBtn" type="submit"
        *ngIf="showBtn()" (click)="signIn()">
  <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login" *ngIf="spinner()">
    <span class="sr-only">Loading...</span>
  </i>
  Sign In
</button>
    <!-- <button class="btn btn-primary signInBtn" type="submit" *ngIf="showBtn()" (click)="signIn()">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login" *ngIf="spinner()">
        <span class="sr-only">Loading...</span>
    </i>
    Sign In</button> -->
    <p class="fgtpwd"><a (click)="forgotpass()">Forgot Password?</a></p>
    <p class="regtrNew">Don't have an account? <a (click)="signUp()"> Sign Up</a></p>
 
    </div>
   </form>
</div>
